import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { Component } from 'react';
import { withAnalyticsEvents } from '@atlaskit/analytics-next';
import createEventPayload from '../../analytics.codegen';
// eslint-disable-next-line @repo/internal/react/no-class-components
export class BaseErrorBoundary extends Component {
  constructor(props) {
    super(props);

    _defineProperty(this, "fireAnalytics", analyticsErrorPayload => {
      var _window, _window$navigator, _analyticsErrorPayloa, _analyticsErrorPayloa2;

      const {
        createAnalyticsEvent,
        channel
      } = this.props;
      createAnalyticsEvent(createEventPayload('ui.linkPicker.unhandledErrorCaught', {
        browserInfo: ((_window = window) === null || _window === void 0 ? void 0 : (_window$navigator = _window.navigator) === null || _window$navigator === void 0 ? void 0 : _window$navigator.userAgent) || 'unknown',
        error: analyticsErrorPayload.error.toString(),
        componentStack: (_analyticsErrorPayloa = (_analyticsErrorPayloa2 = analyticsErrorPayload.info) === null || _analyticsErrorPayloa2 === void 0 ? void 0 : _analyticsErrorPayloa2.componentStack) !== null && _analyticsErrorPayloa !== void 0 ? _analyticsErrorPayloa : ''
      })).fire(channel);
    });

    this.state = {
      hasError: false
    };
  }

  componentDidCatch(error, info) {
    const {
      onError
    } = this.props;
    const payload = {
      error,
      info
    };
    this.fireAnalytics(payload);
    onError && onError(error, info);
    this.setState({
      hasError: true
    });
  }

  render() {
    const {
      children,
      ErrorComponent
    } = this.props;
    const {
      hasError
    } = this.state;

    if (hasError && ErrorComponent) {
      return /*#__PURE__*/React.createElement(ErrorComponent, null);
    }

    return children;
  }

}
const ErrorBoundary = withAnalyticsEvents()(BaseErrorBoundary);
export default ErrorBoundary;